export default __webpack_public_path__ + "static/media/uk.5ed98924.svg";